import AnalyticsIcon from "../../media/icons/AnalyticsIcon";
import AppearenceIcon from "../../media/icons/AppearenceIcon";
import AudienceIcon from "../../media/icons/AudienceIcon";
import DeliveryIcon from "../../media/icons/DeliveryIcon";
import DiscountIcon from "../../media/icons/DiscountIcon";
import HomeIcon from "../../media/icons/HomeIcon";
import MarketingIcon from "../../media/icons/MarketingIcon";
import OrdersIcon from "../../media/icons/OrdersIcon";
import PaymentsIcon from "../../media/icons/PaymentsIcon";
import PluginsIcon from "../../media/icons/PluginsIcon";
import ProductsIcon from "../../media/icons/ProductsIcon";
import ToolsIcon from "../../media/icons/ToolsIcon";

export const sidebarLinksConfig = [
    {
        title: 'Home',
        icon: <HomeIcon />
    },
    {
        title: 'Orders',
        icon: <OrdersIcon />
    },
    {
        title: 'Products',
        icon: <ProductsIcon />
    },
    {
        title: 'Delivery',
        icon: <DeliveryIcon />
    },
    {
        title: 'Marketing',
        icon: <MarketingIcon />
    },
    {
        title: 'Analytics',
        icon: <AnalyticsIcon />
    },
    {
        title: 'Payments',
        icon: <PaymentsIcon />
    },
    {
        title: 'Tools',
        icon: <ToolsIcon />
    },
    {
        title: 'Discounts',
        icon: <DiscountIcon />
    },
    {
        title: 'Audience',
        icon: <AudienceIcon />
    },
    {
        title: 'Appearence',
        icon: <AppearenceIcon />
    },
    {
        title: 'Plugins',
        icon: <PluginsIcon />
    },
    
]